// TODO: move to betgames-contract-js
export enum RED_BLUE_BETTING_OPTION_CLASS {
    RED = 'RED_WINS',
    DRAW = 'DRAW_WINS',
    BLUE = 'BLUE_WINS',
    CORRECT_RED = 'NUMBER_ROLLED_RED',
    CORRECT_BLUE = 'NUMBER_ROLLED_BLUE',
    CORRECT_RED_BLUE = 'NUMBER_ROLLED_RED_BLUE',
    RED_ODD = 'PIPS_RED_ODD',
    BLUE_ODD = 'PIPS_BLUE_ODD',
    RED_EVEN = 'PIPS_RED_EVEN',
    BLUE_EVEN = 'PIPS_BLUE_EVEN',
    RED_MORE_3_5 = 'PIPS_RED_MORE_3_5',
    BLUE_MORE_3_5 = 'PIPS_BLUE_MORE_3_5',
    RED_LESS_3_5 = 'PIPS_RED_LESS_3_5',
    BLUE_LESS_3_5 = 'PIPS_BLUE_LESS_3_5',
    SUM_ODD = 'PIPS_SUM_ODD',
    SUM_EVEN = 'PIPS_SUM_EVEN',
    SUM_LESS_4_5 = 'PIPS_SUM_LESS_4_5',
    SUM_MORE_4_5 = 'PIPS_SUM_MORE_4_5',
    SUM_LESS_5_5 = 'PIPS_SUM_LESS_5_5',
    SUM_MORE_5_5 = 'PIPS_SUM_MORE_5_5',
    SUM_LESS_6_5 = 'PIPS_SUM_LESS_6_5',
    SUM_MORE_6_5 = 'PIPS_SUM_MORE_6_5',
    SUM_LESS_7_5 = 'PIPS_SUM_LESS_7_5',
    SUM_MORE_7_5 = 'PIPS_SUM_MORE_7_5',
    SUM_LESS_8_5 = 'PIPS_SUM_LESS_8_5',
    SUM_MORE_8_5 = 'PIPS_SUM_MORE_8_5',
    SUM_LESS_9_5 = 'PIPS_SUM_LESS_9_5',
    SUM_MORE_9_5 = 'PIPS_SUM_MORE_9_5',
}
